import clsx from "clsx";
import { Button as MUIButton, ButtonProps } from "@material-ui/core";
import { useStyles } from "./button.styles";

export const Button = (props: ButtonProps) => {
  const { children, ...rest } = props;
  const isOutlined = rest.variant === "outlined";
  const isContained = rest.variant === "contained";
  const classes = useStyles();

  return (
    <MUIButton
      {...rest}
      className={clsx(
        classes.button,
        { [classes.outlined]: isOutlined },
        { [classes.contained]: isContained },
        { [classes.secondary]: !isContained && !isOutlined },
        { [rest.className]: rest.className }
      )}
    >
      {children}
    </MUIButton>
  );
};
